"use client";
import { FlagIcons } from "@/components/icons/icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { languages, TLanguages } from "@/i18n/i18n";
import { getCookie, setCookie } from "cookies-next";
import { useParams, usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export function I18nToggle() {
  const router = useRouter();
  const params = useParams<{ lang?: TLanguages }>();
  const pathname = usePathname() || "";
  const slugLang = params.lang;

  // 1) Init: tenta slug → cookie → fallback "pt"
  const deriveInitial = (): TLanguages => {
    if (slugLang && languages.includes(slugLang)) {
      return slugLang;
    }
    const cookieLang = getCookie("NEXT_LOCALE") as string | undefined;
    if (cookieLang && languages.includes(cookieLang as TLanguages)) {
      return cookieLang as TLanguages;
    }
    return "en";
  };

  const [language, setLanguage] = useState<TLanguages>(deriveInitial);

  // 2) Se o user navegar via back/forward, mantemos em sincronia
  useEffect(() => {
    const nextLang = deriveInitial();
    if (nextLang !== language) {
      setLanguage(nextLang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.lang]);

  const handleLanguageChange = (newLang: TLanguages) => {
    // 3) Atualiza state e cookie
    setLanguage(newLang);
    setCookie("NEXT_LOCALE", newLang, {
      path: "/",
      // maxAge em segundos → aqui 10 anos
      maxAge: 60 * 60 * 24 * 365 * 10,
    });
    // 4) Monta a nova rota trocando só o slug.
    //    Se estiver em /en/foo, vira /pt/foo; se /foo, vira /pt/foo
    const segments = pathname
      .split("/")
      .map((seg) => seg)
      .slice(2); // descarta ["", currentSlug]
    const restOfPath = segments.length ? `/${segments.join("/")}` : "";
    router.push(`/${newLang}${restOfPath}`);
  };

  return (
    <div className="flex items-center space-x-2">
      <Select value={language} onValueChange={handleLanguageChange}>
        <SelectTrigger className="flex items-center space-x-2">
          <SelectValue placeholder="Select a language" />
        </SelectTrigger>
        <SelectContent className="max-w-fit">
          <SelectItem value="pt" className="flex items-center justify-center">
            <FlagIcons.brasil className="w-6 h-6" />
          </SelectItem>
          <SelectItem value="en" className="flex items-center justify-center">
            <FlagIcons.uk className="w-6 h-6" />
          </SelectItem>
          <SelectItem value="de" className="flex items-center justify-center">
            <FlagIcons.deutschland className="w-6 h-6" />
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
